<template>
  <div>

<!--
  <h2>Player</h2>

<table class="table table-hover">
  <thead class="table-dark">
    <tr>
      <th>Teraz gram:</th>
      <th>nic!</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td>Mark</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>Jacob</td>
    </tr>
  </tbody>
</table>
-->

  <hr>
  <h2 class="mb-3">Lista najbogatszych</h2>
  <table class="table table-hover">
    <thead class="table-light">
      <tr>
        <th scope="col">#</th>
        <th>Obywatel Bronk</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in najbogatsi" :key="item">
        <th scope="row">{{ index+1 }}</th>
        <td>{{ item[0] }} ({{ item[1] }})</td>
      </tr>
    </tbody>
  </table>

  <p class="clead" v-if="odpad">Najbiedniejszy odpad na serwerze: <strong>{{odpad[0]}} ({{odpad[1]}})</strong></p>

  <hr>
  <div class="panel">
    <button type="button" class="btn-close" aria-label="Close" @click="hideSection($event)"></button>
    <h2 class="mb-3">Status Karakalli</h2>

    <!--
    <div class="row">
      <div class="col-3 p-1">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Karakalla</h5>
            <p class="card-text">Nie ma powodów do świętowania.</p>
            <a href="#" class="btn btn-primary">Powiadom mnie</a>
          </div>
        </div>
      </div>

      <div class="col-3 p-1">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Zero</h5>
            <p class="card-text">Nie ma powodów do świętowania.</p>
            <a href="#" class="btn btn-primary">Powiadom mnie</a>
          </div>
        </div>
      </div>

      <div class="col-3 p-1">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Powerpoint</h5>
            <p class="card-text">Nie ma powodów do świętowania.</p>
            <a href="#" class="btn btn-primary">Powiadom mnie</a>
          </div>
        </div>
      </div>

      <div class="col-3 p-1">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Papa</h5>
            <p class="card-text">Nie ma powodów do świętowania.</p>
            <button @click="registerCwel($event)" class="btn btn-primary">Powiadom mnie</button>
          </div>
        </div>
      </div>
      
    </div>
    -->

    <p class="clead" v-if="!karakalla">Nie ma powodów do świętowania.</p>
    <p class="clead" v-else>KURWA NIE WIERZĘ, MAMY TO!!!!!!!!!!!!!!!!!!!!!!!!!!</p>

  </div>

  <!--
  <p class="clead" v-if="!karakalla">Nie ma powodów do świętowania.</p>
  <p class="clead" v-else>KURWA NIE WIERZĘ, MAMY TO!!!!!!!!!!!!!!!!!!!!!!!!!!</p>
  -->

  <hr>
  <div class="panel">
    <button type="button" class="btn-close" aria-label="Close" @click="hideSection($event)"></button>

    <h2>Klub Cwela</h2>

    <div class="col-12 p-1">
        <div class="card">
          <div class="card-body">
            <div class="row text-start">
      <div class="col-auto">
        <img src="https://upload.wikimedia.org/wikipedia/commons/a/ad/Gree-07.jpg" style="max-width:100px;">
      </div>
      <div class="col">
        <p>Witamy w elitarnym <strong>Klubie Cwela</strong>.
        Jeśli masz ochotę pobzikać, możesz wyrazić zgodę na otrzymywanie powiadomień informujących o najważniejszych wydarzeniach tego pontyfikatu.</p>
        <div class="row">
          <div class="col-auto">
            <input type="password" class="form-control" id="inputPassword" placeholder="Hasło">
          </div>
          <div class="col">
            <button @click="registerCwel" class="btn btn-success" id="registerButton">Zarejestruj mnie w Klubie Cwela już teraz!</button>
          </div>
        </div>
      </div>
    </div>
          </div>
        </div>
      </div>
  </div>



  <hr>
  <h2 class="mb-3">Pomoc społeczna</h2>

  <table class="table table-hover">
    <thead class="table-dark">
      <tr>
        <th scope="col">#</th>
        <th>Komenda</th>
        <th>Cena</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in commands" :key="item.name">
        <th scope="row">{{ index+1 }}</th>
        <td>{{ item.name }}</td>
        <td>{{ item.price }}</td>
      </tr>
    </tbody>
  </table>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },

  data() {
    return {
      commands: [],
      najbogatsi: [],
      odpad: null,
      karakalla: null,
    }
  },

  methods: {
    registerCwel(event) {
      askNotificationPermission(event.target);
    },
    hideSection(event) {
      var d = event.target.nextElementSibling.nextElementSibling.style.display;
      if (d == "none") {
        event.target.nextElementSibling.nextElementSibling.style.display = "";
      } else {
        event.target.nextElementSibling.nextElementSibling.style.display = "none";
      }
    }
  },

  created: function() {
    axios.get('https://api-bimbot.cybryda.org')
      .then(response =>{
        this.commands = response.data.commands;
        this.najbogatsi = response.data.money.wealthiest;
        this.odpad = response.data.money.odpad;

        for (let i=0; i<this.najbogatsi.length; i++) {
          this.najbogatsi[i][1] = abbreviateNumber(this.najbogatsi[i][1]);
        }

    })

    axios.get('https://api-bimbot.cybryda.org/nekrolog')
      .then(response =>{
        this.karakalla = response.data.zdechl;
    })

  },

  mounted: function() {
    if (Notification.permission === 'granted') {
      document.getElementById("registerButton").innerText = "Otrzymujesz już nasze powiadomienia!";
    }
  }

}

function abbreviateNumber(value) {
    return new Intl.NumberFormat('pl-PL', {notation: "compact", maximumFractionDigits: 0 }).format(value);
}

function askNotificationPermission(notificationBtn) {
  // function to actually ask the permissions
  function handlePermission() {
    // set the button to shown or hidden, depending on what the user answers
    if (Notification.permission === 'granted') {
      notificationBtn.innerText = "Zostałeś zarejestrowany w klubie cwela!";
      notificationBtn.classList.remove("btn-success");
      notificationBtn.classList.remove("btn-danger");
      notificationBtn.classList.add("btn-primary");

      regWorker();
    } else {
      notificationBtn.innerText = "Kurwa, lipa!"
      notificationBtn.classList.remove("btn-success");
      notificationBtn.classList.add("btn-danger");
    }
  }

  // Let's check if the browser supports notifications
  if (!('Notification' in window)) {
    console.log("This browser does not support notifications.");
  } else if (checkNotificationPromise()) {
    Notification.requestPermission().then((permission) => {
      handlePermission(permission);
    });
  } else {
    Notification.requestPermission((permission) => {
      handlePermission(permission);
    });
  }
}

function checkNotificationPromise() {
  try {
    Notification.requestPermission().then();
  } catch (e) {
    return false;
  }

  return true;
}

function sendNotification(text) {
  const options = {
      'body': text,
      'icon': "data:image/png;base64,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"
    }
    new Notification("Klub Cwela", options);
}


// (B) REGISTER SERVICE WORKER
async function regWorker () {
  // (B1) YOUR PUBLIC KEY - CHANGE TO YOUR OWN!
  const publicKey = "BC5jofp95cls9Q1N6i_NlDhLYdOB6vjxgD9Jf1X7daEAeUhWs3eIKV5SYrg8iVI-YOQuES1zdHiTdxp9pHPmH2E";
 
  // (B2) REGISTER SERVICE WORKER
  navigator.serviceWorker.register("/notifications.js", { scope: "/" });
 
  // (B3) SUBSCRIBE TO PUSH SERVER
  navigator.serviceWorker.ready
  .then(reg => {
    reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: publicKey
    })
    .then(
      // (B3-1) OK - TEST PUSH NOTIFICATION
      sub => {
        const data = {
          'data': sub,
          'endpoint': 'klub',
          'password': document.getElementById("inputPassword").value
        };

        axios.put('https://api-bimbot.cybryda.org/register', data)
          .then(response =>{
            console.log(response);
            sendNotification("Gratulacje, od teraz będziesz otrzymywał powiadomienia z Klubu Cwela!")
          })
          .catch(err => {
            console.log(err);
            if (err.response.status === 401) {
              var notificationBtn = document.getElementById("registerButton");
              notificationBtn.innerText = "Nie dla psa, złe hasło!";
              notificationBtn.classList.remove("btn-success");
              notificationBtn.classList.add("btn-danger");
              //alert("Ty psie, hasło złe!");
            } else {
              alert("Nie udało się zarejestrować!");
            }
          })
        
      },
 
      // (B3-2) ERROR!
      err => {
        alert("Coś nie pykło: ", err)
      }
    );
  });
}

</script>

<style>
.clead {
  font-size: 1.25rem;
}
.panel {
  position: relative;
}
.btn-close {
  position: absolute;
  top:0;
  right:0;
}
</style>
